/**
 * Where "Get the app" sends people who need an authenticator app for
 * two-step verification. Any TOTP app works (WeCo issues standard
 * `otpauth://` codes), so until our own is published these point at
 * Google Authenticator.
 *
 * TODO: once the We-Co Authenticator (bundle `io.wecodeforyou.weCoAuthenticator`)
 * is in the App Store and Google Play, set VITE_AUTHENTICATOR_IOS_URL /
 * VITE_AUTHENTICATOR_ANDROID_URL to its listings (or change the fallbacks here).
 */
const GOOGLE_AUTHENTICATOR_IOS = "https://apps.apple.com/app/google-authenticator/id388497605";
const GOOGLE_AUTHENTICATOR_ANDROID =
  "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2";

export const AUTHENTICATOR_APP_LINKS = {
  ios: import.meta.env.VITE_AUTHENTICATOR_IOS_URL || GOOGLE_AUTHENTICATOR_IOS,
  android: import.meta.env.VITE_AUTHENTICATOR_ANDROID_URL || GOOGLE_AUTHENTICATOR_ANDROID,
} as const;
